import React from 'react'
import { Store } from '../../context/store'
import { useInterval } from '../../hooks'

const AutoDataReload = ({ children }) => {
    const { state: { user }, actions: { setTimestamp } } = Store()
    const refresh = user ? user.refresh : 0

    useInterval(() => {
        const date = new Date().getTime()
        setTimestamp(date)
    }, refresh * 60000)

    return (
        <>
            {children}
        </>
    )
}

export default AutoDataReload
